<template>
    <div class="max-w-7xl mx-auto">
        <h1 class="mt-16 text-4xl ml-10 py-8 flex 2xl:ml-0">
        Flytider
        </h1>
        <div class="h-36 max-w-7xl mx-10 mb-24 border rounded-l-lg rounded-r-lg flex 2xl:mx-auto">
            <div
                v-for="flight in flights"
                class="flex-grow border-r last:border-none"
            >
                <div class="h-full p-8 flex flex-col">
                    <div class="flex items-center">
                        <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.7147 12.8807C11.9872 13.6083 10.5196 15.0758 9.4141 16.1813C8.63306 16.9624 7.36826 16.9623 6.58721 16.1813C5.50159 15.0957 4.06112 13.6552 3.28661 12.8807C0.683109 10.2772 0.683109 6.05612 3.28661 3.45262C5.89012 0.849126 10.1112 0.849126 12.7147 3.45262C15.3182 6.05612 15.3182 10.2772 12.7147 12.8807Z"
                                fill="white"
                            />
                            <path
                                d="M10.5007 8.16667C10.5007 9.54738 9.38139 10.6667 8.00067 10.6667C6.61996 10.6667 5.50066 9.54738 5.50066 8.16667C5.50066 6.78595 6.61996 5.66667 8.00067 5.66667C9.38139 5.66667 10.5007 6.78595 10.5007 8.16667Z"
                                fill="white"
                            />
                            <path
                                d="M12.7147 12.8807C11.9872 13.6083 10.5196 15.0758 9.4141 16.1813C8.63306 16.9624 7.36826 16.9623 6.58721 16.1813C5.50159 15.0957 4.06112 13.6552 3.28661 12.8807C0.683109 10.2772 0.683109 6.05612 3.28661 3.45262C5.89012 0.849126 10.1112 0.849126 12.7147 3.45262C15.3182 6.05612 15.3182 10.2772 12.7147 12.8807Z"
                                stroke="#212121"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10.5007 8.16667C10.5007 9.54738 9.38139 10.6667 8.00067 10.6667C6.61996 10.6667 5.50066 9.54738 5.50066 8.16667C5.50066 6.78595 6.61996 5.66667 8.00067 5.66667C9.38139 5.66667 10.5007 6.78595 10.5007 8.16667Z"
                                stroke="#212121"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <h1 class="ml-3 text-lg lg:text-2xl">
                            {{ flight.from }} - {{ flight.to }}
                        </h1>
                    </div>
                    <p class="text-md text-gray-500">
                        {{ flight.airline }}
                    </p>
                    <p class="mt-1 text-md text-gray-500">
                        {{ flight.date }} {{ flight.time }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const flights = [
    {
        from: 'Oslo OSL',
        to: 'Nice NCE',
        airline: 'Norwegian',
        airport: 'Gardermoen',
        date: '23. September 22',
        time: 'kl. 10.30',
    },
    {
        from: 'Oslo OSL',
        to: 'Nice NCE',
        airline: 'Norwegian',
        airport: 'Gardermoen',
        date: '23. September 22',
        time: 'kl. 10.30',
    },
];
</script>
